import { Eye, Users, Percent, TrendingUp, BarChart3 } from "lucide-react";

export function ConversionAnalytics({ analytics }) {
  if (!analytics) return null;

  return (
    <div className="mb-12" data-testid="analytics-section">
      <div className="flex items-center gap-2 mb-6">
        <BarChart3 className="w-5 h-5 text-[#FF3B30]" />
        <h3 className="font-heading text-lg uppercase tracking-wider text-white">Conversion Analytics</h3>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
        <div className="bg-[#111111] border border-[#262626] p-6" data-testid="analytics-total-views">
          <Eye className="w-6 h-6 text-[#A855F7] mb-3" />
          <p className="text-3xl font-heading text-white">{analytics.total_views}</p>
          <p className="text-xs uppercase tracking-[0.2em] text-[#A3A3A3] font-body mt-1">Total Page Views</p>
        </div>
        <div className="bg-[#111111] border border-[#262626] p-6" data-testid="analytics-total-signups">
          <Users className="w-6 h-6 text-[#32D74B] mb-3" />
          <p className="text-3xl font-heading text-white">{analytics.total_signups}</p>
          <p className="text-xs uppercase tracking-[0.2em] text-[#A3A3A3] font-body mt-1">Total Signups</p>
        </div>
        <div className="bg-[#111111] border border-[#262626] p-6" data-testid="analytics-conversion">
          <Percent className="w-6 h-6 text-[#FF3B30] mb-3" />
          <p className="text-3xl font-heading text-white">{analytics.conversion_rate}%</p>
          <p className="text-xs uppercase tracking-[0.2em] text-[#A3A3A3] font-body mt-1">Overall Conversion</p>
        </div>
        <div className="bg-[#111111] border border-[#262626] p-6" data-testid="analytics-week-conversion">
          <TrendingUp className="w-6 h-6 text-[#007AFF] mb-3" />
          <p className="text-3xl font-heading text-white">{analytics.this_week.conversion_rate}%</p>
          <p className="text-xs uppercase tracking-[0.2em] text-[#A3A3A3] font-body mt-1">This Week Conversion</p>
        </div>
      </div>
      <div className="bg-[#111111] border border-[#262626] p-6">
        <h4 className="font-heading text-sm uppercase tracking-[0.15em] text-[#A3A3A3] mb-4">This Week</h4>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          <div>
            <p className="text-2xl font-heading text-white">{analytics.this_week.views}</p>
            <p className="text-xs text-[#A3A3A3] font-body">Views</p>
          </div>
          <div>
            <p className="text-2xl font-heading text-white">{analytics.this_week.signups}</p>
            <p className="text-xs text-[#A3A3A3] font-body">Signups</p>
          </div>
          <div>
            <p className="text-2xl font-heading text-white">{analytics.this_week.students}</p>
            <p className="text-xs text-[#A3A3A3] font-body">Students</p>
          </div>
          <div>
            <p className="text-2xl font-heading text-white">{analytics.this_week.coaches + analytics.this_week.investors}</p>
            <p className="text-xs text-[#A3A3A3] font-body">Coaches + Investors</p>
          </div>
        </div>
      </div>
    </div>
  );
}
